import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import SearchBar from '../Components/SearchBar';
import {
    getAllInvoices, getDueAmounts, setInvoicePaymentMedium, updateStatusForFinance, getBudgetAmount, insertbudgetamount,
    updatePriority, updateCommentInInvoice, updatePayableAmountInInvoice
} from '../store/actions/invoiceActions';
import { getallMasterData } from '../store/actions/masterActions';
import { connect } from 'react-redux'
// import formatDate from '../Classes/FormatDate'
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import DropdownFlat from '../Components/DropdownFlat'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import DocumentCommentAdvancePopUp from '../Components/DocumentCommentAdvancePopUp';
import authInstance from '../Classes/AuthHandler';
import { faWindowRestore } from '@fortawesome/free-solid-svg-icons';
//import { Button } from 'react-bootstrap';
import swal from '@sweetalert/with-react';
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import Select from "react-select";
import env from '../ENV';
import toast from 'react-hot-toast';
import { Accordion, Card } from 'react-bootstrap';
import Loading from '../Components/Loader';
import { getPaymentTermDocuments, PaymentTermDocumentsApprovalByPMs, GetDocumentsFromPaymentTermsByPoIdMultiple } from '../store/actions/poDetailsActions'
const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

function formatedDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

class ReqPayment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoicetabledata: [],
            DocumentCommentAdvancePopUpModal: false,
            supplierName: "ABC Tech Inc.",
            select: true,
            checked: [],
            checkedPOID: [],
            selectAll: false,
            modal: false,
            addbudgetmodal: false,
            budgetinfomodal: false,
            paymentMethod: [],
            selectedpaymentmethod: "",
            select: false,
            selectRecall: false,
            selected: [],
            sortByDueDate: [],
            sortByPo: [],
            sortByProject: [],
            alldueDates: [],
            checkedArray: [],
            checkedArrayRecall: [],
            budget: 0, budgetamountId: "",
            update_budget: 0,
            Curr_Day: "",
            finalLastDay: "",
            paybleAmount: "",
            comments: "",
            varId: "",
            selectedData: [],
            dropdownarray: [
                { value: 1, status: "Low" },
                { value: 2, status: "Medium" },
                { value: 3, status: "High" },
                { value: 4, status: "Hold" },
            ],
            invoicetabledata: [],
            allpos: [],
            allprojectCodes: [],
            invoiceDataForPendingPayment: [],
            invoiceDataSendForPayment: [],
            invoiceDataPendingForApproval: [],
            AdvanceDeduction: "",
            RetentionDeduction: {},
            LDDeduction: "",
            TDSDeduction: "",
            OthersDeduction: "",
            ReasonForOthersDeduction: "",
            SAPDocNo: "",
            SAPDocDate: "",
            TotalValueForPending: 0,
            TotalValueForOthers: 0,
            TotalValueForForwarded: 0,
            InvoiceNo: "",
            InvoiceDate: "",
            DueDateEdited: "",
            ExchangeRate: "",
            InvoiceAmount: "",
            budgetTrail: [],
            totalBudget: "",
            searchTerm: new URLSearchParams(this.props.location.search).get("searchTerm") ? new URLSearchParams(this.props.location.search).get("searchTerm") : "",
            searchForOptions: [
                {
                    label: 'Vendor Name', value: 'Vendor Name'
                },
                {
                    label: 'Plant Code', value: 'Plant Code'
                },
                {
                    label: 'PO Number', value: 'PO Number'
                },
                {
                    label: 'Invoice Number', value: 'Invoice Number'
                },
            ],
            searchFor: new URLSearchParams(this.props.location.search).get("searchFor") ? new URLSearchParams(this.props.location.search).get("searchFor") : "",
            searchForItem: [],
        }
        this.togglebutton = this.togglebutton.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSingleCheckboxChange = this.handleSingleCheckboxChange.bind(this);
        this.modal = this.modal.bind(this);
        this.addbudgetmodal = this.addbudgetmodal.bind(this);
        this.budgetinfomodal = this.budgetinfomodal.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.handlesendtofinance = this.handlesendtofinance.bind(this);
        this.handlebudgetchange = this.handlebudgetchange.bind(this);
        this.handlesavebudget = this.handlesavebudget.bind(this);
        this.handleprioritize = this.handleprioritize.bind(this);
        this.formatDate = this.formatDate.bind(this);
        this.handleeditpaybleAmount = this.handleeditpaybleAmount.bind(this);
        this.DocumentCommentAdvancePopUpModal = this.DocumentCommentAdvancePopUpModal.bind(this);



    }

    datemanipulation() {
        var curr = new Date;
        var StartDate = this.formatDate(new Date(curr.setDate(curr.getDate() - curr.getDay())));
        var EndDate = this.formatDate(new Date(curr.setDate(curr.getDate() - curr.getDay() + 6)));
        console.log(StartDate, EndDate, "opp")
        this.setState({ Curr_Day: StartDate, finalLastDay: EndDate })
    }

    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    modalSubmit = async () => {
        let uniqueArray = [...new Set(this.state.checkedArray)];
        let invoices = this.state.invoiceDataForPendingPayment
        let count = 0;
        for (let i = 0; i < invoices.length; i++) {
            if (uniqueArray.includes(invoices[i].InvoiceId) && parseFloat(invoices[i].OthersDeduction) > 0 && (invoices[i].ReasonForOthersDeduction == '0' || (invoices[i].ReasonForOthersDeduction).trim() == '')) {
                count = count + 1
            }
        }
        console.log(count, 'counttt')
        if (count > 0) {
            swal("Please enter in the Reason for others for selected PO's", { icon: "error" })
            return false;
        }
        for (let index = 0; index < uniqueArray.length; index++) {
            await this.props.updateStatusForFinance(2, uniqueArray[index]).then(() => {
                toast.success(`Invoice ${uniqueArray[index]} sent for payment to respective stake holders`, {
                    duration: 3000
                });
            })

        }
        await this.setState({ checkedArray: [], select: false })
        await this.dataSyns()
    }

    handlesendtofinance() {
        var role = Object.keys(authInstance.getRoles())[0]
        var group = Object.keys(authInstance.getGroups())[0]
        let array = []
        let uniqueArray = [...new Set(this.state.checkedArray)];
        uniqueArray.map(item => {
            array.push(item)
        })

        console.log(array, "77777777")

        if (role == 8 && group == 9) {
            for (let i = 0; i < array.length; i++) {
                this.props.updateStatusForFinance(3, array[i])
            }
        }
        else if (role == 9 && group == 10) {
            for (let i = 0; i < array.length; i++) {
                this.props.updateStatusForFinance(5, array[i])
            }
        }
        else if (role == 10 && group == 11) {
            for (let i = 0; i < array.length; i++) {
                this.props.updateStatusForFinance(5, array[i])
            }
        }
        else if (role == 7 && group == 7) {
            for (let i = 0; i < array.length; i++) {
                this.props.updateStatusForFinance(6, array[i])
            }
        }


        window.location.reload()
        // this.props.getAllInvoices(role,group)
    }

    handleprioritize = async () => {
        let array = []
        let uniqueArray = [...new Set(this.state.checkedArray)];

        if (uniqueArray.length == this.state.selectedData.length) {
            this.state.selectedData.map(async (item) => {
                console.log(item)
                await this.props.updatePriority(item.invoiceid, item.priority).then(async () => {
                    await this.dataSyns()
                })
            })

        }
        else {
            swal("Please check the data", { icon: "error" })
        }
        // window.location.reload()
    }
    handlebudgetchange(value) {
        // console.log(e.target.value)
        this.setState({ update_budget: parseFloat(value) })
    }
    handlesavebudget() {
        // console.log("updatebudget=", this.state.update_budget, "paybleAmount=", paybleAmount)
        var currDate = this.state.Curr_Day.split("/").reverse().join("-")
        var endDate = this.state.finalLastDay.split("/").reverse().join("-")
        console.log(currDate, endDate, "pop")
        this.props.insertbudgetamount({
            BudgetAmountId: 0,
            Amount: this.state.update_budget,
            StartDate: currDate,
            EndDate: endDate,
            userId: authInstance.getUserID()
        }).then(() => {
            toast.success(`Budget is set from ${currDate} to ${endDate}`, {
                duration: 3000
            });
        })
        this.resetbudget()
        this.dataSyns()
    }
    resetbudget() {
        this.setState({
            update_budget: 0.00
        })
        this.addbudgetmodal()

    }
    addbudgetmodal() {
        this.setState({ addbudgetmodal: !this.state.addbudgetmodal });

        if (this.state.addbudgetmodal == true) {
            this.setState({ opacity: "" })
        }
        else {
            this.setState({ opacity: "0.2" })
        }
    }
    budgetinfomodal() {
        this.setState({ budgetinfomodal: !this.state.budgetinfomodal });

        if (this.state.budgetinfomodal == true) {
            this.setState({ opacity: "" })
        }
        else {
            this.setState({ opacity: "0.2" })
        }
    }

    modal() {
        this.setState({ modal: !this.state.modal });

        if (this.state.modal == true) {
            this.setState({ opacity: "" })
        }
        else {
            this.setState({ opacity: "0.2" })
        }
    }

    handleSelect = async (e, invoiceId) => {
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            selectedpaymentmethod: e.target.value,
        }).then(() => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
        })
    }
    handleAdvanceDeduction = async (value, index, InvoiceAmount) => {
        if (parseFloat(value) > parseFloat(InvoiceAmount)) {
            swal("Please check the Deduction Amount", { icon: "error" })
            return false
        }
        let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
        invoiceDataForPendingPayment[index].AdvanceDeduction = value
        await this.setState({
            invoiceDataForPendingPayment,
            AdvanceDeduction: value,
        })
    }
    handleRetentionDeduction = async (value, index, InvoiceAmount) => {
        if (parseFloat(value) > parseFloat(InvoiceAmount)) {
            swal("Please check the Deduction Amount", { icon: "error" })
            return false
        }
        let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
        invoiceDataForPendingPayment[index].RetentionDeduction = value
        await this.setState({
            invoiceDataForPendingPayment,
            RetentionDeduction: value
        })
    }
    handleLDDeduction = async (value, index, InvoiceAmount) => {
        if (parseFloat(value) > parseFloat(InvoiceAmount)) {
            swal("Please check the Deduction Amount", { icon: "error" })
            return false
        }
        let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
        invoiceDataForPendingPayment[index].LDDeduction = value
        await this.setState({
            invoiceDataForPendingPayment,
            LDDeduction: value,
        })
    }
    handleTDSDeduction = async (value, index, InvoiceAmount) => {
        if (parseFloat(value) > parseFloat(InvoiceAmount)) {
            swal("Please check the Deduction Amount", { icon: "error" })
            return false
        }
        let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
        invoiceDataForPendingPayment[index].TDSDeduction = value
        await this.setState({
            invoiceDataForPendingPayment,
            TDSDeduction: value
        })
    }
    handleOthersDeduction = async (value, index, InvoiceAmount) => {
        if (parseFloat(value) > parseFloat(InvoiceAmount)) {
            swal("Please check the Deduction Amount", { icon: "error" })
            return false
        }
        let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
        invoiceDataForPendingPayment[index].OthersDeduction = value
        await this.setState({
            invoiceDataForPendingPayment,
            OthersDeduction: value
        })
    }
    handleReasonForOthersDeduction = async (e, index) => {
        let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
        invoiceDataForPendingPayment[index].ReasonForOthersDeduction = e.target.value
        await this.setState({
            invoiceDataForPendingPayment,
            ReasonForOthersDeduction: e.target.value
        })
    }
    handleSAPDocNo = async (e, index) => {
        let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
        invoiceDataForPendingPayment[index].SAPDocNo = e.target.value
        await this.setState({
            invoiceDataForPendingPayment,
            SAPDocNo: e.target.value
        })
    }
    handleInvoiceNo = async (e, index) => {
        let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
        invoiceDataForPendingPayment[index].InvoiceNo = e.target.value
        await this.setState({
            invoiceDataForPendingPayment,
            InvoiceNo: e.target.value
        })
    }
    handleExchangeRate = async (val, index) => {
        console.log(val, "popouuy")
        let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
        invoiceDataForPendingPayment[index].ExchangeRate = val
        await this.setState({
            invoiceDataForPendingPayment,
            ExchangeRate: val
        })
    }
    handleInvoiceAmount = async (value, index) => {
        console.log(value, "E.target.value")
        let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
        invoiceDataForPendingPayment[index].InvoiceAmount = value
        await this.setState({
            invoiceDataForPendingPayment,
            InvoiceAmount: value
        })
    }
    handleSAPDocDate = async (e, index, invoiceId) => {
        let roles = Object.keys(authInstance.getRoles())[0]
        let groups = Object.keys(authInstance.getGroups())[0]
        let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
        invoiceDataForPendingPayment[index].SAPDocDate = e.target.value
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            SAPDocDate: e.target.value,
            Indicator: 8
        }).then(async () => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
            await this.props.getAllInvoices(roles, groups)
        })
        await this.setState({
            invoiceDataForPendingPayment,
            SAPDocDate: e.target.value
        })
    }
    handleDueDate = async (e, index, invoiceId) => {
        let roles = Object.keys(authInstance.getRoles())[0]
        let groups = Object.keys(authInstance.getGroups())[0]
        let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
        invoiceDataForPendingPayment[index].DueDate = e.target.value
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            DueDate: e.target.value,
            Indicator: 9
        }).then(async () => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
            await this.dataSyns()
        })
        await this.setState({
            invoiceDataForPendingPayment,
            DueDateEdited: e.target.value
        })
    }
    handleInvoiceDate = async (e, index, invoiceId) => {
        let roles = Object.keys(authInstance.getRoles())[0]
        let groups = Object.keys(authInstance.getGroups())[0]
        let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
        invoiceDataForPendingPayment[index].InvoiceDate = e.target.value
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            InvoiceDate: e.target.value,
            Indicator: 10
        }).then(async () => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
            await this.dataSyns()
        })
        await this.setState({
            invoiceDataForPendingPayment,
            InvoiceDate: e.target.value
        })
    }

    handleDropdowndata = (e, invoiceId) => {
        var selectedData = [...this.state.selectedData]
        var index = selectedData.findIndex((element) => element.invoiceid == invoiceId)
        console.log(index, '@@@@@@@@@@@@@@@@@@@@@@2')
        if (index == -1) {
            selectedData.push({
                invoiceid: invoiceId,
                priority: e.target.value
            })
        } else {
            selectedData[index].priority = e.target.value
        }

        this.setState({
            selectedData: selectedData,
        }, () => console.log(this.state.selectedData, "selectedData")
        )
    }
    dataSyns = async () => {
        var role = Object.keys(authInstance.getRoles())[0]
        var group = Object.keys(authInstance.getGroups())[0]
        console.log(role, group)
        let invoiceDataForPendingPayment = []
        let invoiceDataSendForPayment = []
        var invoiceDataPendingForApproval = []
        let TotalValueForPending = 0
        let TotalValueForOthers = 0
        let TotalValueForForwarded = 0

        let paymentMethod = []
        let PurchaseOrderId = []

        let searchData = {
            searchTerm: this.state.searchTerm,
            searchFor: this.state.searchFor,
            role: role,
            group: group,
        }
        await this.props.getAllInvoices(searchData)
        await this.props.invoices.allInvoices.recordset.map((elem) => {
            PurchaseOrderId.push(elem.PurchaseOrderId)
        })
        console.log(PurchaseOrderId, "POIDDD")
        await this.props.GetDocumentsFromPaymentTermsByPoIdMultiple({ PoId: PurchaseOrderId })
        if (this.props.invoices.allInvoices && this.props.invoices.allInvoices.recordsets && this.props.invoices.allInvoices.recordsets.length > 0) {
            let allInvoices = await this.props.invoices.allInvoices.recordset
            for (let i = 0; i < allInvoices.length; i++) {
                await this.props.PaymentTermDocumentsApprovalByPMs(allInvoices[i].PurchaseOrderId)
                if (allInvoices[i].TypeFor === '' || allInvoices[i].TypeFor == null || allInvoices[i].TypeFor === undefined) {
                    allInvoices[i].TypeFor = null
                }

                var approvalDetailsByCPMorTPMPartial = await this.props.poDetails.paymentTermApprovalByCPMandTPM.recordsets[1].filter((item) => item.approvalStatus == 1 && (item.TypeFor == allInvoices[i].TypeFor || allInvoices[i].TypeFor == null) && item.PaymentType == allInvoices[i].PaymentType && item.PoId == allInvoices[i].PurchaseOrderId)

                var uniqueApprovals = await this.props.poDetails.paymentTermApprovalByCPMandTPM.recordset.filter((item) => item.approvalStatus == 1 && (item.TypeFor == allInvoices[i].TypeFor || allInvoices[i].TypeFor == null) && item.PaymentType == allInvoices[i].PaymentType && item.PoId == allInvoices[i].PurchaseOrderId && (item.PaymentType !== 3 || item.InvoiceId == allInvoices[i].InvoiceId))

                console.log("lkjhgfdxcvbwds1", uniqueApprovals, allInvoices[i].PurchaseOrderId, allInvoices[i].InvoiceId)

                const uniqueApprovalsCopy = [...uniqueApprovals]; // create a copy to avoid modifying the original array
                const matchingIndex = await uniqueApprovalsCopy.findIndex(item => item.DocumentId == allInvoices[i].InvoiceDocId);
                if (matchingIndex >= 0) {
                    const matchingItem = uniqueApprovalsCopy.splice(matchingIndex, 1)[0]; // remove matching item from array
                    uniqueApprovalsCopy.unshift(matchingItem); // add matching item to beginning of array
                    uniqueApprovals = uniqueApprovalsCopy; // replace original array with modified copy
                }
                const approvalDetailsByCPMorTPM = await uniqueApprovals.reduce((accumulator, current) => {
                    const approvedByName = current.approvedByName;
                    const approvedById = current.ActedGroupId;
                    const documentTypeId = current.DocumentTypeId;
                    if (current.TypeFor == 'null' || current.TypeFor === '' || current.TypeFor == null || current.TypeFor === undefined) {
                        current.TypeFor = null
                    }
                    if (current.TypeFor == allInvoices[i].TypeFor && (current.PaymentType === allInvoices[i].PaymentType || current.DocumentId === allInvoices[i].InvoiceDocId)) {
                        const existingItem = accumulator.find(item => item.approvedByName === approvedByName && item.ActedGroupId === approvedById && item.DocumentTypeId == documentTypeId);
                        if (!existingItem) {
                            accumulator.push(current);
                        }
                    }
                    return accumulator;
                }, []);

                var requiredApprovalPayments = await this.props.poDetails.paymentTermDocumentsMultiplePos.pos.filter((item) => (item.TypeFor == allInvoices[i].TypeFor) && item.PaymentTypeId == allInvoices[i].PaymentType && item.PurchaseOrderId == allInvoices[i].PurchaseOrderId && item.DocumentTypeName !== "Order Acceptance")


                const requiredApprovalCount = await requiredApprovalPayments.reduce((accumulator, current) => {
                    const approvedByName = current.GroupName;
                    const approvedById = current.ActingDeptGroupId;
                    const documentTypeId = current.DocumentTypeId;
                    const existingItem = accumulator.find(item => item.GroupName === approvedByName && item.ActingDeptGroupId === approvedById && item.DocumentTypeId == documentTypeId);
                    if (!existingItem) {
                        accumulator.push(current);
                    }
                    return accumulator;
                }, []);

                console.log("POPOLLLIOIO", approvalDetailsByCPMorTPMPartial, approvalDetailsByCPMorTPM, requiredApprovalCount, allInvoices[i].InvoiceNo, "POPOLLLIOIO", allInvoices[i].PurchaseOrderId)



                if (approvalDetailsByCPMorTPM.find((elem) => elem.DocumentId == allInvoices[i].InvoiceDocId)) {
                    if (requiredApprovalCount.find((elem) => elem.DocumentTypeId === 40)) {
                        if (requiredApprovalCount.find((elem) => elem.ActingDeptGroupId === 19) && requiredApprovalCount.find((elem) => elem.ActingDeptGroupId === 26) && (requiredApprovalCount.length - 1) === approvalDetailsByCPMorTPM.length) {
                            console.log("000", allInvoices[i].PurchaseOrderId)
                            invoiceDataForPendingPayment.push(allInvoices[i])

                        } else if (!requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 7) && approvalDetailsByCPMorTPM.find((elem) => elem.ActedGroupId == 7) && (requiredApprovalCount.length + 1) == approvalDetailsByCPMorTPM.length) {
                            invoiceDataForPendingPayment.push(allInvoices[i])

                        } else if (!requiredApprovalCount.find((elem) => elem.ActingDeptGroupId === 19) && requiredApprovalCount.find((elem) => elem.ActingDeptGroupId === 26) && (requiredApprovalCount.length - 1) < approvalDetailsByCPMorTPM.length) {
                            console.log("001", allInvoices[i].PurchaseOrderId)
                            invoiceDataForPendingPayment.push(allInvoices[i])


                        } else if (requiredApprovalCount.find((elem) => elem.ActingDeptGroupId === 19) && !requiredApprovalCount.find((elem) => elem.ActingDeptGroupId === 26) && (requiredApprovalCount.length - 1) < approvalDetailsByCPMorTPM.length) {
                            await invoiceDataForPendingPayment.push(allInvoices[i])
                            console.log("002", allInvoices[i].PurchaseOrderId)



                        } else if (!requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 19) && !requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 26) && (approvalDetailsByCPMorTPM.length - 1) == (requiredApprovalCount.length)) {
                            invoiceDataForPendingPayment.push(allInvoices[i])
                            console.log("003", allInvoices[i].PurchaseOrderId)


                        } else if (approvalDetailsByCPMorTPM.find((data) => data.approvalStatus === 1 && data.ActedGroupId === 8)) {
                            console.log("00a", allInvoices[i], allInvoices[i].PurchaseOrderId)
                            invoiceDataPendingForApproval.push(allInvoices[i])
                            TotalValueForOthers = parseFloat(TotalValueForOthers) + parseFloat(allInvoices[i].NetPayableAmount)
                        }
                    } else {
                        console.log(approvalDetailsByCPMorTPM, requiredApprovalCount, "plplplplplp", allInvoices[i].PurchaseOrderId)
                        if (requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 19) && requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 26) && requiredApprovalCount.length == approvalDetailsByCPMorTPM.length) {
                            invoiceDataForPendingPayment.push(allInvoices[i])
                            console.log("004", allInvoices[i].PurchaseOrderId)

                        } else if (!requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 7) && approvalDetailsByCPMorTPM.find((elem) => elem.ActedGroupId == 7) && (requiredApprovalCount.length + 1) == approvalDetailsByCPMorTPM.length) {
                            invoiceDataForPendingPayment.push(allInvoices[i])

                        } else if (!requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 19) && requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 26) && requiredApprovalCount.length < approvalDetailsByCPMorTPM.length) {
                            invoiceDataForPendingPayment.push(allInvoices[i])
                            console.log("005", allInvoices[i].PurchaseOrderId)

                        } else if (requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 19) && !requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 26) && requiredApprovalCount.length < approvalDetailsByCPMorTPM.length) {
                            invoiceDataForPendingPayment.push(allInvoices[i])
                            console.log("006", allInvoices[i].PurchaseOrderId)

                        } else if (!requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 19) && !requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 26) && approvalDetailsByCPMorTPM.length === (requiredApprovalCount.length + 2)) {
                            invoiceDataForPendingPayment.push(allInvoices[i])
                            console.log("007", allInvoices[i].PurchaseOrderId)
                        } else if (approvalDetailsByCPMorTPM.find((data) => data.approvalStatus == 1 && data.ActedGroupId == 8)) {
                            console.log("008", allInvoices[i].PurchaseOrderId)
                            invoiceDataPendingForApproval.push(allInvoices[i])
                            TotalValueForOthers = parseFloat(TotalValueForOthers) + parseFloat(allInvoices[i].NetPayableAmount)
                        }
                    }
                }
                else {
                    if (requiredApprovalCount.find((elem) => elem.DocumentTypeId == 40)) {
                        if (requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 19) && requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 26) && (requiredApprovalCount.length - 1) == approvalDetailsByCPMorTPMPartial.length) {
                            console.log("000", allInvoices[i].PurchaseOrderId)
                            invoiceDataForPendingPayment.push(allInvoices[i])

                        } else if (!requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 19) && requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 26) && (requiredApprovalCount.length - 1) < approvalDetailsByCPMorTPMPartial.length) {
                            console.log("001", allInvoices[i].PurchaseOrderId)
                            invoiceDataForPendingPayment.push(allInvoices[i])

                        } else if (!requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 7) && approvalDetailsByCPMorTPM.find((elem) => elem.ActedGroupId == 7) && (requiredApprovalCount.length + 1) == approvalDetailsByCPMorTPM.length) {
                            invoiceDataForPendingPayment.push(allInvoices[i])

                        } else if (requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 19) && !requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 26) && (requiredApprovalCount.length - 1) < approvalDetailsByCPMorTPMPartial.length) {
                            await invoiceDataForPendingPayment.push(allInvoices[i])
                            console.log("002", allInvoices[i].PurchaseOrderId)



                        } else if (!requiredApprovalCount.find((elem) => elem.ActingDeptGroupId === 19) && !requiredApprovalCount.find((elem) => elem.ActingDeptGroupId === 26) && (approvalDetailsByCPMorTPM.length - 1) === (requiredApprovalCount.length)) {
                            invoiceDataForPendingPayment.push(allInvoices[i])
                            console.log("003", allInvoices[i].PurchaseOrderId)
                        } else if (approvalDetailsByCPMorTPMPartial.length > 0) {
                            if (approvalDetailsByCPMorTPMPartial.find((data) => data.approvalStatus === 1 && data.ActedGroupId === 8)) {
                                invoiceDataPendingForApproval.push(allInvoices[i])
                                TotalValueForOthers = parseFloat(TotalValueForOthers) + parseFloat(allInvoices[i].NetPayableAmount)
                            }
                        }
                    }
                    else {
                        console.log(approvalDetailsByCPMorTPMPartial, requiredApprovalCount, allInvoices[i].PurchaseOrderId, "plplplplplpinelse")
                        if (requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 19) && requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 26) && requiredApprovalCount.length == approvalDetailsByCPMorTPMPartial.length) {
                            invoiceDataForPendingPayment.push(allInvoices[i])
                            console.log("004e", allInvoices[i].PurchaseOrderId)

                        } else if (!requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 7) && approvalDetailsByCPMorTPM.find((elem) => elem.ActedGroupId == 7) && (requiredApprovalCount.length + 1) == approvalDetailsByCPMorTPM.length) {
                            invoiceDataForPendingPayment.push(allInvoices[i])

                        } else if (!requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 19) && requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 26) && requiredApprovalCount.length < approvalDetailsByCPMorTPMPartial.length) {
                            invoiceDataForPendingPayment.push(allInvoices[i])
                            console.log("005", allInvoices[i].PurchaseOrderId)

                        } else if (requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 19) && !requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 26) && requiredApprovalCount.length < approvalDetailsByCPMorTPMPartial.length) {
                            invoiceDataForPendingPayment.push(allInvoices[i])
                            console.log("006", allInvoices[i].PurchaseOrderId)

                        } else if (!requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 19) && !requiredApprovalCount.find((elem) => elem.ActingDeptGroupId == 26) && approvalDetailsByCPMorTPMPartial.length === (requiredApprovalCount.length + 2)) {
                            invoiceDataForPendingPayment.push(allInvoices[i])
                            console.log("007", allInvoices[i].PurchaseOrderId)
                        } else if (approvalDetailsByCPMorTPMPartial.find((data) => data.approvalStatus == 1 && data.ActedGroupId == 8)) {
                            invoiceDataPendingForApproval.push(allInvoices[i])
                            TotalValueForOthers = parseFloat(TotalValueForOthers) + parseFloat(allInvoices[i].NetPayableAmount)
                        }
                    }
                }
            }
            allInvoices.map(async (data) => {

            })
            console.log(invoiceDataPendingForApproval, invoiceDataForPendingPayment, "popopopo")
            if ((role == 9 && group == 10) || role == 54) {
                invoiceDataSendForPayment = await this.props.invoices.allInvoices.recordsets[0]
            }
            else {
                invoiceDataSendForPayment = await this.props.invoices.allInvoices.recordsets[1]
                invoiceDataSendForPayment.map(async (elementInv) => {
                    // if (elementInv.Counter < 2) {
                    TotalValueForForwarded = parseFloat(TotalValueForForwarded) + parseFloat(elementInv.NetPayableAmount)
                    // }
                })

            }
            for (let index = 0; index < invoiceDataForPendingPayment.length; index++) {
                TotalValueForPending = parseFloat(TotalValueForPending) + parseFloat(invoiceDataForPendingPayment[index].NetPayableAmount)
                console.log("TotalValueForPending", TotalValueForPending)

            }
            console.log("TotalValueForPending", invoiceDataForPendingPayment)
            await this.setState({ invoiceDataForPendingPayment, invoiceDataSendForPayment, invoiceDataPendingForApproval, TotalValueForPending, TotalValueForOthers, TotalValueForForwarded })
        }
        await this.props.getallMasterData()
        if (this.props.masterReducerData.loading == false) {
            await this.props.masterReducerData.masterdata.recordset.map(item => {
                paymentMethod.push(item)
            })
            await this.setState({ paymentMethod })
        }
        if (role == 8 && group == 8 || role == 9 && group == 10 || role == 8 && group == 9 || role == 54) {
            var EndDate = this.state.finalLastDay
            var StartDate = this.state.Curr_Day

            await this.props.getBudgetAmount({
                StartDate: StartDate,
                EndDate: EndDate
            })
            let result = await this.props.invoices.budgetamount.recordsets
            let totalBudget = 0
            let budgetTrail = []
            if (result.length > 0) {
                totalBudget = result.length > 0 && result[1] && result[1] && result[1][0].totalBudget
                budgetTrail = result[2]
            }
            await this.setState({ totalBudget, budgetTrail })

        }
    }


    componentDidMount = async () => {

        await this.datemanipulation()
        await this.props.getDueAmounts()
        await this.dataSyns()

    }

    handlepaybleamount = (e, InvoiceAmount, Index) => {
        let invoicetabledata = this.state.invoicetabledata
        if (parseInt(e.target.value) <= parseInt(InvoiceAmount)) {
            invoicetabledata[Index].PayableAmount = e.target.value
            this.setState({ paybleAmount: e.target.value, invoicetabledata: invoicetabledata })
            console.log(e.target.value, " $$$$$$$ ")
        }

        else
            swal("Please check the Payable Amount", { icon: "error" })
    }
    handlepayableAmount = (invoiceID, e) => {
        console.log(invoiceID, "&&&&")
    }


    handleComments = (e) => {
        this.setState({ comments: e.target.value })
    }

    handleeditpaybleAmount = async (invoiceID) => {
        console.log(invoiceID, this.state.paybleAmount)
        var group = Object.keys(authInstance.getGroups())[0]
        await this.props.updatePayableAmountInInvoice(invoiceID, this.state.paybleAmount, group)

        await window.location.reload()
    }

    handleeditComment = (invoiceID) => {
        console.log(invoiceID, this.state.comments)
        this.props.updateCommentInInvoice(invoiceID, this.state.comments)
    }

    DocumentCommentAdvancePopUpModal() {
        this.setState({ DocumentCommentAdvancePopUpModal: !this.state.DocumentCommentAdvancePopUpModal });
        this.setState({ RetentionDocumentsModal: false });
        if (this.state.DocumentCommentAdvancePopUpModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    toggleDocumentCommentAdvancePopUpModal = async (e) => {
        await this.setState({ DocumentCommentAdvancePopUpModal: !this.state.DocumentCommentAdvancePopUpModal });
        if (this.state.DocumentCommentAdvancePopUpModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2", varId: "" }
            )
        }
    }

    handleChange = async () => {
        let select = !this.state.select;
        var checkedArray = []
        await this.state.invoiceDataForPendingPayment.map((item, index) => {
            if (select == true) {
                checkedArray.push(item.InvoiceId)
            }
        });
        await this.setState({ select: select, checkedArray });
    };
    handleChangeRecall = async () => {
        let selectRecall = !this.state.selectRecall;
        var checkedArrayRecall = []
        await this.state.invoiceDataSendForPayment.map((item, index) => {
            if (selectRecall == true) {
                checkedArrayRecall.push(item.InvoiceId)
            }
        });
        await this.setState({ selectRecall: selectRecall, checkedArrayRecall });
    };


    togglebutton = (Index) => {
        // console.log(Index)
        var multiCollapseIndex = this.state.multiCollapseIndex

        if (multiCollapseIndex != Index || multiCollapseIndex == '') {

            this.setState({ multiCollapseIndex: Index })
        }
    }
    handleSingleCheckboxChange = (index) => {
        var checkedArray = [...this.state.checkedArray]
        if (!checkedArray.includes(index)) {
            checkedArray.push(index)
        } else {
            checkedArray = checkedArray.filter(item => item !== index)
        }
        this.setState({ checkedArray });
    };
    handleRecallSingleCheckboxChange = (index) => {
        var checkedArrayRecall = [...this.state.checkedArrayRecall]
        if (!checkedArrayRecall.includes(index)) {
            checkedArrayRecall.push(index)
        } else {
            checkedArrayRecall = checkedArrayRecall.filter((item) => item !== index)
        }
        this.setState({ checkedArrayRecall });
    }

    fetchDate(date) {
        let dd = date.getDate().toString()
        let mm = (date.getMonth() + 1).toString()
        if (dd.length < 2)
            dd = "0" + dd
        if (mm.length < 2)
            mm = "0" + mm
        let finalDate = dd + "/" + mm + "/" + date.getFullYear();
        return finalDate;
    }
    daysInMonth(month, year) {
        return new Date(year, month, 0).getDate();
    }
    rowClick = async (index) => {
        await this.setState({ varId: index })
        await this.DocumentCommentAdvancePopUpModal()
    }
    handleSelectDueDate = async (e) => {
        let sortByDueDate = []
        console.log(e, "HHHH")
        if (e.length > 0) {
            e.map((item) => {
                sortByDueDate.push(item.value)
            })
        }
        await this.setState({ sortByDueDate })
        console.log(this.state.sortByDueDate, "HHHH")
    }
    handleSelectPO = async (e) => {
        let sortByPo = []
        console.log(e, "HHHH")
        if (e.length > 0) {
            e.map((item) => {
                sortByPo.push(item.value)
            })
        }
        await this.setState({ sortByPo })
        console.log(this.state.sortByPo, "HHHH")
    }
    handleSelectProject = async (e) => {
        let sortByProject = []
        console.log(e, "HHHH")
        if (e.length > 0) {
            e.map((item) => {
                sortByProject.push(item.value)
            })
        }
        await this.setState({ sortByProject })
        console.log(this.state.sortByProject, "HHHH")
    }
    handleRevise = async () => {
        let array = [...new Set(this.state.checkedArrayRecall)];
        for (let i = 0; i < array.length; i++) {
            await this.props.updateStatusForFinance(1, array[i]).then(() => {
                toast.success(`Recall Successfull`, {
                    duration: 1000
                });
            })
        }
        await this.setState({ checkedArrayRecall: [], selectRecall: false })
        await this.dataSyns()
    }
    handleKeyPressAdvanceDeduction = async (event, val, invoiceId, inv, Index) => {
        let invVal = (parseFloat(inv.InvoiceAmountinINR) - (parseFloat(inv.PrevApprovedAmount)) - ((parseFloat(val) + parseFloat(inv.RetentionDeduction) + parseFloat(inv.LDDeduction) + parseFloat(inv.TDSDeduction) + parseFloat(inv.OthersDeduction)) * parseFloat(inv.ExchangeRate)))
        let role = Object.keys(authInstance.getRoles())[0]
        let group = Object.keys(authInstance.getGroups())[0]
        console.log(val, "val", invVal, invoiceId, "invoiceId")
        if (event.key === 'Enter') {
            if (invVal < 0) {
                let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
                invoiceDataForPendingPayment[Index].AdvanceDeduction = 0
                swal("Please Check the Deduction Amounts", { icon: "error" })
                await this.setState({ AdvanceDeduction: 0, invoiceDataForPendingPayment })
                return false
            }
            event.preventDefault();
            await this.props.setInvoicePaymentMedium({
                InvoiceId: invoiceId,
                AdvanceDeduction: val,
                Indicator: 1
            }).then(async () => {
                toast.success(`Data Saved`, {
                    duration: 1000
                });
                await this.dataSyns()
            })
            return false;
        }
    }
    handleKeyPressRetentionDeduction = async (event, val, invoiceId, inv, Index) => {
        let invVal = (parseFloat(inv.InvoiceAmountinINR) - (parseFloat(inv.PrevApprovedAmount)) - ((parseFloat(val) + parseFloat(inv.AdvanceDeduction) + parseFloat(inv.LDDeduction) + parseFloat(inv.TDSDeduction) + parseFloat(inv.OthersDeduction)) * parseFloat(inv.ExchangeRate)))
        let role = Object.keys(authInstance.getRoles())[0]
        let group = Object.keys(authInstance.getGroups())[0]
        console.log(val, "val", invVal, invoiceId, "invoiceId")
        if (event.key === 'Enter') {
            if (invVal < 0) {
                let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
                invoiceDataForPendingPayment[Index].RetentionDeduction = 0
                swal("Please Check the Deduction Amounts", { icon: "error" })
                await this.setState({ RetentionDeduction: 0, invoiceDataForPendingPayment })
                return false
            }
            event.preventDefault();
            await this.props.setInvoicePaymentMedium({
                InvoiceId: invoiceId,
                RetentionDeduction: val,
                Indicator: 2
            }).then(async () => {
                toast.success(`Data Saved`, {
                    duration: 1000
                });
                await this.dataSyns()
            })
            return false;
        }
    }
    handleKeyPressLDDeduction = async (event, val, invoiceId, inv, Index) => {
        let invVal = (parseFloat(inv.InvoiceAmountinINR) - (parseFloat(inv.PrevApprovedAmount)) - ((parseFloat(val) + parseFloat(inv.RetentionDeduction) + parseFloat(inv.AdvanceDeduction) + parseFloat(inv.TDSDeduction) + parseFloat(inv.OthersDeduction)) * parseFloat(inv.ExchangeRate)))
        let role = Object.keys(authInstance.getRoles())[0]
        let group = Object.keys(authInstance.getGroups())[0]
        if (event.key === 'Enter') {
            if (invVal < 0) {
                let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
                invoiceDataForPendingPayment[Index].LDDeduction = 0
                swal("Please Check the Deduction Amounts", { icon: "error" })
                await this.setState({ LDDeduction: 0, invoiceDataForPendingPayment })
                return false
            }
            event.preventDefault();
            await this.props.setInvoicePaymentMedium({
                InvoiceId: invoiceId,
                LDDeduction: val,
                Indicator: 3
            }).then(async () => {
                toast.success(`Data Saved`, {
                    duration: 1000
                });
                await this.dataSyns()
            })
            return false;
        }
    }
    handleKeyPressTDSDeduction = async (event, val, invoiceId, inv, Index) => {
        let invVal = (parseFloat(inv.InvoiceAmountinINR) - (parseFloat(inv.PrevApprovedAmount)) - ((parseFloat(val) + parseFloat(inv.RetentionDeduction) + parseFloat(inv.LDDeduction) + parseFloat(inv.AdvanceDeduction) + parseFloat(inv.OthersDeduction)) * parseFloat(inv.ExchangeRate)))
        let role = Object.keys(authInstance.getRoles())[0]
        let group = Object.keys(authInstance.getGroups())[0]
        if (event.key === 'Enter') {
            if (invVal < 0) {
                let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
                invoiceDataForPendingPayment[Index].TDSDeduction = 0
                swal("Please Check the Deduction Amounts", { icon: "error" })
                await this.setState({ TDSDeduction: 0, invoiceDataForPendingPayment })
                return false
            }
            event.preventDefault();
            await this.props.setInvoicePaymentMedium({
                InvoiceId: invoiceId,
                TDSDeduction: val,
                Indicator: 4
            }).then(async () => {
                toast.success(`Data Saved`, {
                    duration: 1000
                });
                await this.dataSyns()
            })
            return false;
        }
    }
    handleKeyPressOthersDeduction = async (event, val, invoiceId, inv, Index) => {
        let invVal = (parseFloat(inv.InvoiceAmountinINR) - (parseFloat(inv.PrevApprovedAmount)) - ((parseFloat(val) + parseFloat(inv.RetentionDeduction) + parseFloat(inv.LDDeduction) + parseFloat(inv.TDSDeduction) + parseFloat(inv.AdvanceDeduction)) * parseFloat(inv.ExchangeRate)))
        let role = Object.keys(authInstance.getRoles())[0]
        let group = Object.keys(authInstance.getGroups())[0]
        if (event.key === 'Enter') {
            if (invVal < 0) {
                let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
                invoiceDataForPendingPayment[Index].OthersDeduction = 0
                swal("Please Check the Deduction Amounts", { icon: "error" })
                await this.setState({ OthersDeduction: 0, invoiceDataForPendingPayment })
                return false
            }
            event.preventDefault();
            await this.props.setInvoicePaymentMedium({
                InvoiceId: invoiceId,
                OthersDeduction: val,
                Indicator: 5
            }).then(async () => {
                toast.success(`Data Saved`, {
                    duration: 1000
                });
                await this.dataSyns()
            })
            return false;
        }
    }
    handleKeyPressReasonForOthersDeduction = async (event, val, invoiceId) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            await this.props.setInvoicePaymentMedium({
                InvoiceId: invoiceId,
                ReasonForOthersDeduction: val,
                Indicator: 6
            }).then(async () => {
                toast.success(`Data Saved`, {
                    duration: 1000
                });
                await this.dataSyns()
            })
            return false;
        }
    }
    handleKeyPressSAPDocNo = async (event, val, invoiceId) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            await this.props.setInvoicePaymentMedium({
                InvoiceId: invoiceId,
                SAPDocNo: val,
                Indicator: 7
            }).then(async () => {
                toast.success(`Data Saved`, {
                    duration: 1000
                });
                await this.dataSyns()
            })
            return false;
        }
    }
    handleKeyPressSAPDocDate = async (event, val, invoiceId) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            await this.props.setInvoicePaymentMedium({
                InvoiceId: invoiceId,
                SAPDocDate: val,
                Indicator: 8
            }).then(async () => {
                toast.success(`Data Saved`, {
                    duration: 1000
                });
                await this.dataSyns()
            })
            return false;
        }
    }
    handleKeyPressDueDate = async (event, val, invoiceId) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            await this.props.setInvoicePaymentMedium({
                InvoiceId: invoiceId,
                DueDate: val,
                Indicator: 9
            }).then(async () => {
                toast.success(`Data Saved`, {
                    duration: 1000
                });
                await this.dataSyns()
            })
            return false;
        }
    }
    handleKeyPressInvoiceDate = async (event, val, invoiceId) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            await this.props.setInvoicePaymentMedium({
                InvoiceId: invoiceId,
                InvoiceDate: val,
                Indicator: 10
            }).then(async () => {
                toast.success(`Data Saved`, {
                    duration: 1000
                });
                await this.dataSyns()
            })
            return false;
        }
    }
    handleKeyPressInvoiceNo = async (event, val, invoiceId) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            await this.props.setInvoicePaymentMedium({
                InvoiceId: invoiceId,
                InvoiceNo: val,
                Indicator: 11
            }).then(async () => {
                toast.success(`Data Saved`, {
                    duration: 1000
                });
                await this.dataSyns()
            })
            return false;
        }
    }
    handleKeyPressExchangeRate = async (event, val, invoiceId) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            await this.props.setInvoicePaymentMedium({
                InvoiceId: invoiceId,
                ExchangeRate: val,
                Indicator: 12
            })
            await toast.success(`Data Saved`, {
                duration: 1000
            });
            await this.dataSyns()
            return false;
        }
    }
    handleKeyPressInvoiceAmount = async (event, val, invoiceId) => {

        if (event.key === 'Enter') {
            event.preventDefault();
            console.log(val, "valInvoiceamt")
            await this.props.setInvoicePaymentMedium({
                InvoiceId: invoiceId,
                InvoiceAmount: val,
                Indicator: 13
            }).then(async () => {
                toast.success(`Data Saved`, {
                    duration: 1000
                });
                await this.dataSyns()
            })
            return false;
        }
    }
    onBlurAdvanceDeduction = async (event, val, invoiceId, inv, Index) => {
        let invVal = (parseFloat(inv.InvoiceAmountinINR) - (parseFloat(inv.PrevApprovedAmount)) - ((parseFloat(val) + parseFloat(inv.RetentionDeduction) + parseFloat(inv.LDDeduction) + parseFloat(inv.TDSDeduction) + parseFloat(inv.OthersDeduction)) * parseFloat(inv.ExchangeRate)))
        console.log(val, "val", invVal, invoiceId, "invoiceId")
        if (invVal < 0) {
            let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
            invoiceDataForPendingPayment[Index].AdvanceDeduction = 0
            swal("Please Check the Deduction Amounts", { icon: "error" })
            await this.setState({ AdvanceDeduction: 0, invoiceDataForPendingPayment })
            return false
        }
        event.preventDefault();
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            AdvanceDeduction: val,
            Indicator: 1
        }).then(async () => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
            await this.dataSyns()
        })
    }
    onBlurRetentionDeduction = async (event, val, invoiceId, inv, Index) => {
        let invVal = (parseFloat(inv.InvoiceAmountinINR) - (parseFloat(inv.PrevApprovedAmount)) - ((parseFloat(val) + parseFloat(inv.AdvanceDeduction) + parseFloat(inv.LDDeduction) + parseFloat(inv.TDSDeduction) + parseFloat(inv.OthersDeduction)) * parseFloat(inv.ExchangeRate)))
        console.log(val, "val", invVal, invoiceId, "invoiceId")
        event.preventDefault();
        if (invVal < 0) {
            let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
            invoiceDataForPendingPayment[Index].RetentionDeduction = 0
            swal("Please Check the Deduction Amounts", { icon: "error" })
            await this.setState({ RetentionDeduction: 0, invoiceDataForPendingPayment })
            return false
        }
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            RetentionDeduction: val,
            Indicator: 2
        }).then(async () => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
            await this.dataSyns()
        })
    }
    onBlurLDDeduction = async (event, val, invoiceId, inv, Index) => {
        let invVal = (parseFloat(inv.InvoiceAmountinINR) - (parseFloat(inv.PrevApprovedAmount)) - ((parseFloat(val) + parseFloat(inv.RetentionDeduction) + parseFloat(inv.AdvanceDeduction) + parseFloat(inv.TDSDeduction) + parseFloat(inv.OthersDeduction)) * parseFloat(inv.ExchangeRate)))
        if (invVal < 0) {
            let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
            invoiceDataForPendingPayment[Index].LDDeduction = 0
            swal("Please Check the Deduction Amounts", { icon: "error" })
            await this.setState({ LDDeduction: 0, invoiceDataForPendingPayment })
            return false
        }
        event.preventDefault();
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            LDDeduction: val,
            Indicator: 3
        }).then(async () => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
            await this.dataSyns()
        })
    }
    onBlurTDSDeduction = async (event, val, invoiceId, inv, Index) => {
        let invVal = (parseFloat(inv.InvoiceAmountinINR) - (parseFloat(inv.PrevApprovedAmount)) - ((parseFloat(val) + parseFloat(inv.RetentionDeduction) + parseFloat(inv.LDDeduction) + parseFloat(inv.AdvanceDeduction) + parseFloat(inv.OthersDeduction)) * parseFloat(inv.ExchangeRate)))
        if (invVal < 0) {
            let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
            invoiceDataForPendingPayment[Index].TDSDeduction = 0
            swal("Please Check the Deduction Amounts", { icon: "error" })
            await this.setState({ TDSDeduction: 0, invoiceDataForPendingPayment })
            return false
        }
        event.preventDefault();
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            TDSDeduction: val,
            Indicator: 4
        }).then(async () => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
            await this.dataSyns()
        })
    }
    onBlurOthersDeduction = async (event, val, invoiceId, inv, Index) => {
        let invVal = (parseFloat(inv.InvoiceAmountinINR) - (parseFloat(inv.PrevApprovedAmount)) - ((parseFloat(val) + parseFloat(inv.RetentionDeduction) + parseFloat(inv.LDDeduction) + parseFloat(inv.TDSDeduction) + parseFloat(inv.AdvanceDeduction)) * parseFloat(inv.ExchangeRate)))
        if (invVal < 0) {
            let invoiceDataForPendingPayment = [...this.state.invoiceDataForPendingPayment]
            invoiceDataForPendingPayment[Index].OthersDeduction = 0
            swal("Please Check the Deduction Amounts", { icon: "error" })
            await this.setState({ OthersDeduction: 0, invoiceDataForPendingPayment })
            return false
        }
        event.preventDefault();
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            OthersDeduction: val,
            Indicator: 5
        }).then(async () => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
            await this.dataSyns()
        })
    }
    onBlurReasonForOthersDeduction = async (event, val, invoiceId) => {
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            ReasonForOthersDeduction: val,
            Indicator: 6
        }).then(async () => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
            await this.dataSyns()
        })
    }
    onBlurSAPDocNo = async (event, val, invoiceId) => {
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            SAPDocNo: val,
            Indicator: 7
        }).then(async () => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
            await this.dataSyns()
        })
    }
    onBlurSAPDocDate = async (event, val, invoiceId) => {
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            SAPDocDate: val,
            Indicator: 8
        }).then(async () => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
            await this.dataSyns()
        })
    }
    onBlurDueDate = async (event, val, invoiceId) => {
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            DueDate: val,
            Indicator: 9
        }).then(async () => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
            await this.dataSyns()
        })
    }
    onBlurInvoiceDate = async (event, val, invoiceId) => {
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            InvoiceDate: val,
            Indicator: 10
        }).then(async () => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
            await this.dataSyns()
        })
    }
    onBlurInvoiceNo = async (event, val, invoiceId) => {
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            InvoiceNo: val,
            Indicator: 11
        }).then(async () => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
            await this.dataSyns()
        })
    }
    onBlurExchangeRate = async (event, val, invoiceId) => {
        console.log(val, "popiiopoop")
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            ExchangeRate: val,
            Indicator: 12
        })
        await this.dataSyns()
        await toast.success(`Data Saved`, {
            duration: 1000
        });
    }
    onBlurInvoiceAmount = async (event, val, invoiceId) => {
        await this.props.setInvoicePaymentMedium({
            InvoiceId: invoiceId,
            InvoiceAmount: val,
            Indicator: 13
        }).then(async () => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
            await this.dataSyns()
        })
    }
    handleISearch = (e) => {
        let searchTerm = e.target.value
        this.setState({
            searchTerm
        })
        console.log(this.state.searchTerm)
    }
    handleSearching = async (e) => {
        await this.dataSyns()
    }

    clearFilter = async () => {
        await this.setState({
            searchTerm: '',
            searchFor: '',
            searchForItem: [],
        })
        await this.dataSyns()
    }
    handleSelectSearchFor = async (value) => {
        let searchFor = value
        let searchForItem = [
            {
                label: value, value: value
            }
        ]
        await this.setState({ searchFor, searchForItem })
    }
    render() {
        var roles = authInstance.getRoles()
        var permissions = authInstance.getPermissions()
        var groups = authInstance.getGroups()
        var varId = this.state.varId
        console.log(this.props.poDetails.paymentTermApprovalByCPMandTPM, "this.state.varId")
        try {

            if (this.props.invoices.loading == false) {
                if ((roles[10] == true && groups[11] == true) || (roles[9] == true && groups[10] == true) || (roles[7] == true && groups[7] == true)) {
                    this.state.budget = this.props.invoices.budgetamount.recordset[0].Amount
                    this.state.budgetamountId = this.props.invoices.budgetamount.recordset[0].BudgetAmmountId
                }
            }
        }
        catch (e) { }
        if (this.props.poDetails.loading) {
            return (
                <Loading />
            )
        }
        return (

            <div className="Container-fluid pageheight pl-2 pr-2 pt-2" style={{ marginLeft: "1rem" }} >
                {/*----------Document comment-------------- */}
                {
                    varId ? (<DocumentCommentAdvancePopUp action={this.state.DocumentCommentAdvancePopUpModal} toggleDocumentCommentAdvancePopUpModal={(e) => this.toggleDocumentCommentAdvancePopUpModal(e)} InvoiceId={varId} path='/RequestPayment' />) : null
                }
                {/*----------Document Comment end  */}

                {/* ----Modal Start----- */}

                <Modal isOpen={this.state.modal} >
                    <div className={"modal-bg" + (this.state.modal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header ">
                                <div><h4 >Update Payment Method</h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={this.modal} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>

                        <div >
                            <ModalBody Style="modal-body ">
                                <div className="col-md-12 pt-2">
                                    <div className="row">
                                        <div className="col-md-6 pt-2 " ><b>Method of Payment :</b></div>
                                        <div className="col-md-6 ">
                                            <DropdownFlat defaultopt="" data={this.state.paymentMethod} actions={this.handleSelect} keyObjName={"PaymentMediumId"} valueObjName={"PaymentMediumName"} />
                                        </div>
                                    </div>
                                </div>
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer">
                                <div>
                                    <button className="btn2 btn-sms1 mt-2 ml-4 float-right rounded-pill" onClick={this.modalSubmit} type="submit">Send to Treasury Team</button>
                                    <button type="button" className="btn2 btn-sms1 mt-2 float-right rounded-pill" onClick={this.modal}> Cancel </button>
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>


                {/* ----Modal End-------- */}
                {/* ----Add-Budget Modal Start----- */}

                <Modal isOpen={this.state.addbudgetmodal} >
                    <div className={"modal-bg" + (this.state.addbudgetmodal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header ">
                                <div><h4 >Add Budget</h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={() => this.resetbudget()} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>

                        <div >
                            <ModalBody Style="modal-body ">
                                <div className="col-md-12 pt-2">
                                    <div className="row">
                                        <div className="col-md-6 pt-2 " ><b>Enter Budget :</b></div>
                                        <div className="col-md-6 ">
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.state.update_budget} onValueChange={(value) => this.handlebudgetchange(value)} />
                                        </div>
                                    </div>
                                </div>
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer">
                                <div>
                                    <button type="button" className="btn2 btn-sms1 mt-2 float-right rounded-pill" onClick={() => this.resetbudget()}> Cancel </button>
                                    <button className="btn2 btn-sms1 mt-2 ml-4 float-right rounded-pill" onClick={this.handlesavebudget} type="submit">Add Budget</button>
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>


                {/* ----Add-Budget Modal End-------- */}
                {/* ----Budget-info Modal Start----- */}

                <Modal isOpen={this.state.budgetinfomodal} className="modal-lg">
                    <div className={"modal-bg" + (this.state.budgetinfomodal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header ">
                                <div><h4 >Total Budget Trail</h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={this.budgetinfomodal} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>

                        <div >
                            <ModalBody Style="modal-body modalbodysWideBudget">
                                <div className="col-md-12 pt-2">
                                    <div className="row">
                                        <div className="col-md-12 pt-2 ">
                                            <table border="1" className="table1 table " >
                                                <tr className="headerbar ">
                                                    <th>Amount</th>
                                                    <th>Start Date</th>
                                                    <th>End Date</th>
                                                    <th>Acted Person</th>
                                                </tr>
                                                {this.state.budgetTrail && this.state.budgetTrail.length > 0 && this.state.budgetTrail.map((item, Index) =>

                                                    <tr className="rows headeralign">
                                                        <td>INR {numberWithCommas(item.Amount)}</td>
                                                        <td>{formatedDate(item.StartDate)}</td>
                                                        <td>{formatedDate(item.EndDate)}</td>
                                                        <td>{item.ActedPerson}</td>

                                                    </tr>
                                                )}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </ModalBody>
                        </div>
                    </div>
                </Modal>


                {/* ----Budget-info Modal End-------- */}


                <div className="row pt-2 pr-4">
                    <div className="col-3">
                        <b>REQUESTED PAYMENTS</b>
                    </div>
                    <div className="col-3">
                        {
                            roles[9] && groups[10] ?
                                <button className="btn2 btn-sms1 float-right rounded-pill" type="submit" onClick={this.addbudgetmodal}> Add Budget </button>
                                : null
                        }
                    </div>
                    {/* <div className="col-3">
                        {
                            roles[9] && groups[10] ?
                                <button className="btn2 btn-sms1 float-right rounded-pill" type="submit" onClick={this.handlesavebudget}> Save Budget </button>
                                : null
                        }
                    </div> */}

                    <div className="col-6">
                        <div className="from-group " >
                            <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" clearFilter={this.clearFilter} clear={true} btnName="" ShowSearchFor={true} searchForOptions={this.state.searchForOptions} searchForItem={this.state.searchForItem} SelectSearchForHandler={this.handleSelectSearchFor} />
                        </div>
                    </div>
                </div>

                <div className="col-12 pr-4 pb-2">
                    {!roles[8] && !groups[8] ?
                        <div className="border-radius-modal p-2">

                            <div className="form-group row mb-0" >
                                <div className="col ">
                                    <label for="input" className=" form-label"><b>Already Due:</b></label>
                                </div>
                                <div className="col ">
                                    <label for="input" className="form-label"><b>Due In Current Week:</b></label>
                                </div>
                                <div className="col">
                                    <label for="input" className="form-label"><b>Subsequent Due:</b></label>
                                </div>
                                <div className="col ">
                                    <label for="input" className="form-label"><b>Total Due:</b></label>
                                </div>
                                <div className="col">
                                    <label for="input" className="form-label">
                                        <b>Total Approved Budget:</b>
                                        <FontAwesomeIcon style={{ marginLeft: "12px" }} icon={"info-circle"} color="black" title="View" size="lg" cursor={"pointer"} onClick={this.budgetinfomodal} />
                                    </label>
                                </div>
                            </div>
                            <div className="form-group row" >
                                <div className="col">
                                    {(this.props.invoices.loading == false) ?

                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.props.invoices.dueAmounts.alreadyDue} readOnly />
                                        </div>
                                        :
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value="INR 0000" readOnly />
                                        </div>
                                    }
                                </div>
                                <div className="col ">
                                    {(this.props.invoices.loading == false) ?
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.props.invoices.dueAmounts.currentWeekDue} readOnly />
                                        </div>

                                        :
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value="INR 0000" readOnly />
                                        </div>
                                    }
                                </div>
                                <div className="col ">
                                    {(this.props.invoices.loading == false) ?
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.props.invoices.dueAmounts.subsequentDue} readOnly />
                                        </div>

                                        :
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value="INR 0000" readOnly />
                                        </div>

                                    }
                                </div>
                                <div className="col ">
                                    {(this.props.invoices.loading == false) ?
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.props.invoices.dueAmounts.totalDue} readOnly />
                                        </div>

                                        :
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value="INR 0000" readOnly />
                                        </div>

                                    }
                                </div>

                                <div className="col">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text">INR</span>
                                        </div>
                                        <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.state.totalBudget} readOnly />
                                    </div>
                                </div>
                            </div>
                        </div>
                        :permissions[22] ?
                        <div className="border-radius-modal p-2">

                            <div className="form-group row mb-0" >
                                <div className="col ">
                                    <label for="input" className=" form-label"><b>Already Due:</b></label>
                                </div>
                                <div className="col ">
                                    <label for="input" className="form-label"><b>Due In Current Week:</b></label>
                                </div>
                                <div className="col">
                                    <label for="input" className="form-label"><b>Subsequent Due:</b></label>
                                </div>
                                <div className="col ">
                                    <label for="input" className="form-label"><b>Total Due:</b></label>
                                </div>
                                <div className="col">
                                    <label for="input" className="form-label">
                                        <b>Total Approved Budget:</b>
                                        <FontAwesomeIcon style={{ marginLeft: "12px" }} icon={"info-circle"} color="black" title="View" size="lg" cursor={"pointer"} onClick={this.budgetinfomodal} />
                                    </label>
                                </div>
                            </div>
                            <div className="form-group row" >
                                <div className="col">
                                    {(this.props.invoices.loading == false) ?

                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.props.invoices.dueAmounts.alreadyDue} readOnly />
                                        </div>
                                        :
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value="INR 0000" readOnly />
                                        </div>
                                    }
                                </div>
                                <div className="col ">
                                    {(this.props.invoices.loading == false) ?
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.props.invoices.dueAmounts.currentWeekDue} readOnly />
                                        </div>

                                        :
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value="INR 0000" readOnly />
                                        </div>
                                    }
                                </div>
                                <div className="col ">
                                    {(this.props.invoices.loading == false) ?
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.props.invoices.dueAmounts.subsequentDue} readOnly />
                                        </div>

                                        :
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value="INR 0000" readOnly />
                                        </div>

                                    }
                                </div>
                                <div className="col ">
                                    {(this.props.invoices.loading == false) ?
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.props.invoices.dueAmounts.totalDue} readOnly />
                                        </div>

                                        :
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value="INR 0000" readOnly />
                                        </div>

                                    }
                                </div>

                                <div className="col">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text">INR</span>
                                        </div>
                                        <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.state.totalBudget} readOnly />
                                    </div>
                                </div>
                            </div>
                        </div>: null}
                </div>
                {roles[8] && groups[8] ?
                    <>
                        <Accordion defaultActiveKey="0" flush>
                            <Card event>
                                <Accordion.Toggle as={"h5"} className="accordion-background mb-0 pb-2 pl-2 pr-4 pt-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(1)} onClick={() => this.setState({ activeEventKey: JSON.stringify(1) })}>
                                    <div className="row pl-2 pr-2">
                                        <div className="col-md-9">
                                            Invoice approved for payments
                                        </div>
                                        <div className="col-md-3">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend ">
                                                    <span className="input-group-text">INR</span>
                                                </div>
                                                <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.state.TotalValueForPending} readOnly />
                                            </div>
                                        </div>
                                    </div>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey={JSON.stringify(1)}>
                                    <Card.Body>
                                        <div className="row">
                                            <div className="col">
                                                <button className="btn2 btn-sms1 float-right rounded-pill" type="submit" onClick={this.modalSubmit}> Send For Payment </button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="w-block1 pr-4 sticky" >
                                                <div className="scrolling-bar-table wrap">
                                                    <table border="1" className="table1 table-exp" >
                                                        <>
                                                            <tr className="headerbar sticky-inner ">
                                                                <th> <input type="checkbox" onClick={this.handleChange} checked={this.state.select} /></th>
                                                                <th style={{ minWidth: "59px" }}>Action</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Plant Code</th>
                                                                <th style={{ minWidth: "120px" }}>Invoice No</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Payment Counter</th>
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "82px" }}>Invoice Date</th>
                                                                {/* Editable Due Date */}
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "82px" }}>Due Date</th>
                                                                <th style={{ minWidth: "255px" }}>Vendor Name</th>
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "149px" }}>Invoice Type</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Vendor Type</th>
                                                                <th>PO No</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Project code</th>
                                                                <th>Exchange Rate</th>
                                                                <th>currency</th>
                                                                <th>Invoice Amount</th>
                                                                <th>Invoice Amount in (INR)</th>
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "197px" }}>Advance Deduction</th>
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "197px" }}>Retention Deduction</th>
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "197px" }}>LD Deduction</th>
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "197px" }}>TDS Deduction</th>
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "197px" }}>Others Deduction</th>
                                                                {/* Text Field */}
                                                                <th>Reason For Others</th>
                                                                {/* Text Field */}
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "171px" }}>SAP Doc. Number</th>
                                                                {/* Date Field */}
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "82px" }}>SAP Doc. Date</th>
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "171px" }}>Net Payable Amount</th>
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "131px" }}>Payment Method</th>
                                                                <th style={{ minWidth: "126px" }}>Status</th>
                                                            </tr>
                                                        </>
                                                        <>
                                                            {this.state.invoiceDataForPendingPayment.map((item, Index) =>

                                                                <tr className="rows headeralign">
                                                                    <td><input type="checkbox" disabled={item.InvoiceStatusId == '7' ? true : false} checked={this.state.checkedArray.includes(item.InvoiceId) ? true : false} onChange={(event) => this.handleSingleCheckboxChange(item.InvoiceId)} value="" /></td>
                                                                    <td>
                                                                        <Link to={{ pathname: '/PoAcceptanceTrail', state: { poId: item.PurchaseOrderId, poSAPId: item.POSAPId, InvoiceId: item.InvoiceId, InvoiceStatusId: item.InvoiceStatusId } }}>
                                                                            <FontAwesomeIcon icon={"eye"} color="black" title="View" size="lg" />
                                                                        </Link>
                                                                        <FontAwesomeIcon icon={"sms"} style={{ marginLeft: "10px" }} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(item.InvoiceId)} />
                                                                    </td>
                                                                    <td>{item.PlantCode}</td>
                                                                    <td>
                                                                        <input type="text" className="form-control" value={item.InvoiceNo} onChange={(e) => this.handleInvoiceNo(e, Index, item.InvoiceId)} onKeyPress={(e) => this.handleKeyPressInvoiceNo(e, this.state.InvoiceNo, item.InvoiceId)} onBlur={(e) => this.onBlurInvoiceNo(e, item.InvoiceNo, item.InvoiceId)} />
                                                                    </td>
                                                                    <td>{item.Counter > 0 ? `Part-${item.Counter}` : ''}</td>
                                                                    <td>
                                                                        <input type="date" className="form-control" value={formatedDate(item.InvoiceDate)} onChange={(e) => this.handleInvoiceDate(e, Index, item.InvoiceId)} onKeyPress={(e) => this.handleKeyPressInvoiceDate(e, this.state.InvoiceDate, item.InvoiceId)} onBlur={(e) => this.onBlurInvoiceDate(e, item.InvoiceDate, item.InvoiceId)} />
                                                                    </td>
                                                                    <td>
                                                                        <input type="date" className="form-control" value={formatedDate(item.DueDate)} onChange={(e) => this.handleDueDate(e, Index, item.InvoiceId)} onKeyPress={(e) => this.handleKeyPressDueDate(e, this.state.DueDateEdited, item.InvoiceId)} onBlur={(e) => this.onBlurDueDate(e, item.DueDate, item.InvoiceId)} />
                                                                    </td>
                                                                    <td>{item.VendorName + " - " + item.VendorSapId}</td>
                                                                    <td>{item.PaymentTypeName + " Against " + item.TypeFor}</td>
                                                                    <td>{item.SSIType == "" ? "NON MSME" : "MSME"}</td>
                                                                    <td>{item.POSAPId}</td>
                                                                    <td>
                                                                        {item.WBSNo ? item.WBSNo.includes('ET') ? (item.WBSNo).slice(0, 11) : (item.WBSNo).slice(0, 6) : ""}
                                                                    </td>
                                                                    <td>
                                                                        <CurrencyInput allowNegativeValue={false} decimalScale="4" className="form-control" value={item.ExchangeRate} onValueChange={(value, name) => this.handleExchangeRate(value, Index)} onKeyPress={(e) => this.handleKeyPressExchangeRate(e, this.state.ExchangeRate ? this.state.ExchangeRate : item.ExchangeRate, item.InvoiceId)} onBlur={(e) => this.onBlurExchangeRate(e, this.state.ExchangeRate ? this.state.ExchangeRate : item.ExchangeRate, item.InvoiceId)} />
                                                                    </td>
                                                                    <td>{item.CurrencyType}</td>
                                                                    <td className="align-middle amount-text">{item.CurrencyType + ' ' + numberWithCommas(item.InvoiceAmount)} </td>
                                                                    <td className="align-middle amount-text">{numberWithCommas(item.InvoiceAmountinINR)}</td>
                                                                    <td>
                                                                        <div className="input-group">
                                                                            <div className="input-group-prepend ">
                                                                                <span className="input-group-text">{item.CurrencyType}</span>
                                                                            </div>
                                                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control" value={item.AdvanceDeduction} onValueChange={(value, name) => this.handleAdvanceDeduction(value, Index, item.InvoiceAmount)} onKeyPress={(e) => this.handleKeyPressAdvanceDeduction(e, this.state.AdvanceDeduction, item.InvoiceId, item, Index)} onBlur={(e) => this.onBlurAdvanceDeduction(e, item.AdvanceDeduction, item.InvoiceId, item, Index)} />
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="input-group">
                                                                            <div className="input-group-prepend ">
                                                                                <span className="input-group-text">{item.CurrencyType}</span>
                                                                            </div>
                                                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" id={item.InvoiceId} className="form-control" value={item.RetentionDeduction} onValueChange={(value, name) => this.handleRetentionDeduction(value, Index, item.InvoiceAmount)} onKeyPress={(e) => this.handleKeyPressRetentionDeduction(e, this.state.RetentionDeduction, item.InvoiceId, item, Index)} onBlur={(e) => this.onBlurRetentionDeduction(e, item.RetentionDeduction, item.InvoiceId, item, Index)} />
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="input-group">
                                                                            <div className="input-group-prepend ">
                                                                                <span className="input-group-text">{item.CurrencyType}</span>
                                                                            </div>
                                                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control" value={item.LDDeduction} onValueChange={(value, name) => this.handleLDDeduction(value, Index, item.InvoiceAmount)} onKeyPress={(e) => this.handleKeyPressLDDeduction(e, this.state.LDDeduction, item.InvoiceId, item, Index)} onBlur={(e) => this.onBlurLDDeduction(e, item.LDDeduction, item.InvoiceId, item, Index)} />
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="input-group">
                                                                            <div className="input-group-prepend ">
                                                                                <span className="input-group-text">{item.CurrencyType}</span>
                                                                            </div>
                                                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control" value={item.TDSDeduction} onValueChange={(value, name) => this.handleTDSDeduction(value, Index, item.InvoiceAmount)} onKeyPress={(e) => this.handleKeyPressTDSDeduction(e, this.state.TDSDeduction, item.InvoiceId, item, Index)} onBlur={(e) => this.onBlurTDSDeduction(e, item.TDSDeduction, item.InvoiceId, item, Index)} />
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="input-group">
                                                                            <div className="input-group-prepend ">
                                                                                <span className="input-group-text">{item.CurrencyType}</span>
                                                                            </div>
                                                                            <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control" value={item.OthersDeduction} onValueChange={(value, name) => this.handleOthersDeduction(value, Index, item.InvoiceAmount)} onKeyPress={(e) => this.handleKeyPressOthersDeduction(e, this.state.OthersDeduction, item.InvoiceId, item, Index)} onBlur={(e) => this.onBlurOthersDeduction(e, item.OthersDeduction, item.InvoiceId, item, Index)} />
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <input type="text" className="form-control" value={item.ReasonForOthersDeduction != '0' ? item.ReasonForOthersDeduction : ""} onChange={(e) => this.handleReasonForOthersDeduction(e, Index)} onKeyPress={(e) => this.handleKeyPressReasonForOthersDeduction(e, this.state.ReasonForOthersDeduction, item.InvoiceId)} onBlur={(e) => this.onBlurReasonForOthersDeduction(e, item.ReasonForOthersDeduction, item.InvoiceId)} />
                                                                    </td>
                                                                    {/* Text Field */}
                                                                    <td>
                                                                        <input type="text" className="form-control" value={item.SAPDocNo} onChange={(e) => this.handleSAPDocNo(e, Index)} onKeyPress={(e) => this.handleKeyPressSAPDocNo(e, this.state.SAPDocNo, item.InvoiceId)} onBlur={(e) => this.onBlurSAPDocNo(e, item.SAPDocNo, item.InvoiceId)} />
                                                                    </td>
                                                                    {/* Date Field */}
                                                                    <td>
                                                                        <input type="date" className="form-control" value={item.SAPDocDate ? formatedDate(item.SAPDocDate) : item.SAPDocDate} onChange={(e) => this.handleSAPDocDate(e, Index, item.InvoiceId)} onKeyPress={(e) => this.handleKeyPressSAPDocDate(e, this.state.SAPDocDate, item.InvoiceId)} onBlur={(e) => this.onBlurSAPDocDate(e, item.SAPDocDate, item.InvoiceId)} />
                                                                    </td>
                                                                    <td className="align-middle amount-text">{numberWithCommas((parseFloat(item.InvoiceAmountinINR) - (item.PrevApprovedAmount ? parseFloat(item.PrevApprovedAmount) : 0) - (((item.AdvanceDeduction ? parseFloat(item.AdvanceDeduction) : 0) + (item.RetentionDeduction ? parseFloat(item.RetentionDeduction) : 0) + (item.LDDeduction ? parseFloat(item.LDDeduction) : 0) + (item.TDSDeduction ? parseFloat(item.TDSDeduction) : 0) + (item.OthersDeduction ? parseFloat(item.OthersDeduction) : 0)) * parseFloat(item.ExchangeRate))))}</td>
                                                                    <td>
                                                                        <DropdownFlat defaultopt="Select Option" selectedValue={item.PaymentMediumId || ''} data={this.state.paymentMethod} actions={(e) => this.handleSelect(e, item.InvoiceId)} keyObjName={"PaymentMediumId"} valueObjName={"PaymentMediumName"} />
                                                                    </td>
                                                                    <td>{item.InvoiceStatusName}</td>
                                                                </tr>
                                                            )}
                                                        </>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                        <Accordion defaultActiveKey="0" flush>
                            <Card event>
                                <Accordion.Toggle as={"h5"} className="accordion-background mb-0 pb-2 pl-2 pr-4 pt-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(2)} onClick={() => this.setState({ activeEventKey: JSON.stringify(2) })}>
                                    <div className="row pl-2 pr-2">
                                        <div className="col-md-9">
                                            Invoice in process
                                        </div>
                                        <div className="col-md-3">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend ">
                                                    <span className="input-group-text">INR</span>
                                                </div>
                                                <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.state.TotalValueForOthers} readOnly />
                                            </div>
                                        </div>
                                    </div>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey={JSON.stringify(2)}>
                                    <Card.Body>
                                        <div className="row">
                                            <div className="w-block1 pr-4 sticky" >
                                                <div className="scrolling-bar-table wrap">
                                                    <table border="1" className="table1 table-exp " >
                                                        <>
                                                            <tr className="headerbar sticky-inner ">
                                                                <th style={{ minWidth: "59px" }}>Action</th>
                                                                <th style={{ whitespace: "break-spaces" }}>Plant Code</th>
                                                                <th>Invoice No</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Payment Counter</th>
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "82px" }}>Invoice Date</th>
                                                                {/* Editable Due Date */}
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "82px" }}>Due Date</th>
                                                                <th style={{ minWidth: "255px" }}>Vendor Name</th>
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "149px" }}>Invoice Type</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Vendor Type</th>
                                                                <th>PO No</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Project code</th>
                                                                <th>currency</th>
                                                                <th>Invoice Amount</th>
                                                                <th>Invoice Amount in (INR)</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Advance Deduction</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Retention Deduction</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>LD Deduction</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>TDS Deduction</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Others Deduction</th>
                                                                {/* Text Field */}
                                                                <th>Reason For Others</th>
                                                                {/* Text Field */}
                                                                <th style={{ whiteSpace: "break-spaces" }}>SAP Doc. Number</th>
                                                                {/* Date Field */}
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "82px" }}>SAP Doc. Date</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Net Payable Amount</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Payment Method</th>
                                                                <th style={{ minWidth: "126px" }}>Status</th>
                                                            </tr>
                                                        </>
                                                        <>
                                                            {this.state.invoiceDataPendingForApproval.map((item, Index) =>

                                                                <tr className="rows headeralign">
                                                                    <td>
                                                                        <Link to={{ pathname: '/PoAcceptanceTrail', state: { poId: item.PurchaseOrderId, poSAPId: item.POSAPId, InvoiceId: item.InvoiceId, InvoiceStatusId: item.InvoiceStatusId } }}>
                                                                            <FontAwesomeIcon icon={"eye"} color="black" title="View" size="lg" />
                                                                        </Link>
                                                                        <FontAwesomeIcon icon={"sms"} style={{ marginLeft: "10px" }} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(item.InvoiceId)} />
                                                                    </td>
                                                                    <td>{item.PlantCode}</td>
                                                                    <td>
                                                                        {item.InvoiceNo}
                                                                    </td>
                                                                    <td>{item.Counter > 0 ? `-${item.Counter}` : ''}</td>
                                                                    <td>{dateFormater(this.formatDate(item.InvoiceDate))}</td>
                                                                    <td>{dateFormater(this.formatDate(item.DueDate))}</td>
                                                                    <td>{item.VendorName + " - " + item.VendorSapId}</td>
                                                                    <td>{item.PaymentTypeName + " Against " + item.TypeFor}</td>
                                                                    <td>{item.SSIType == "" ? "NON MSME" : "MSME"}</td>
                                                                    <td>{item.POSAPId}</td>
                                                                    <td>
                                                                        {item.WBSNo ? item.WBSNo.includes('ET') ? (item.WBSNo).slice(0, 11) : (item.WBSNo).slice(0, 6) : ""}
                                                                    </td>
                                                                    <td>{item.CurrencyType}</td>
                                                                    <td className="align-middle amount-text">{item.InvoiceAmount ? numberWithCommas(item.InvoiceAmount) : 0} </td>
                                                                    <td className="align-middle amount-text">{item.InvoiceAmountinINR ? numberWithCommas(item.InvoiceAmountinINR) : 0}</td>
                                                                    <td className="align-middle amount-text">{item.AdvanceDeduction ? numberWithCommas(item.AdvanceDeduction) : 0}</td>
                                                                    <td className="align-middle amount-text">{item.RetentionDeduction ? numberWithCommas(item.RetentionDeduction) : 0}</td>
                                                                    <td className="align-middle amount-text">{item.LDDeduction ? numberWithCommas(item.LDDeduction) : 0}</td>
                                                                    <td className="align-middle amount-text">{item.TDSDeduction ? numberWithCommas(item.TDSDeduction) : 0}</td>
                                                                    <td className="align-middle amount-text">{item.OthersDeduction ? numberWithCommas(item.OthersDeduction) : 0}</td>
                                                                    <td>{item.ReasonForOthersDeduction != '0' ? item.ReasonForOthersDeduction : ''}</td>
                                                                    <td>{item.SAPDocNo}</td>
                                                                    <td>{item.SAPDocDate ? dateFormater(item.SAPDocDate) : ""}</td>
                                                                    <td className="align-middle amount-text">{numberWithCommas(item.NetPayableAmount)}</td>
                                                                    <td>{item.PaymentMediumName}</td>
                                                                    <td>{item.InvoiceStatusName}</td>
                                                                </tr>
                                                            )}
                                                        </>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                        <Accordion defaultActiveKey="0" flush>
                            <Card event>
                                <Accordion.Toggle as={"h5"} className="accordion-background mb-0 pb-2 pl-2 pr-4 pt-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(3)} onClick={() => this.setState({ activeEventKey: JSON.stringify(3) })}>
                                    <div className="row pl-2 pr-2">
                                        <div className="col-md-9">
                                            Invoice send for payments
                                        </div>
                                        <div className="col-md-3">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend ">
                                                    <span className="input-group-text">INR</span>
                                                </div>
                                                <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.state.TotalValueForForwarded} readOnly />
                                            </div>
                                        </div>
                                    </div>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey={JSON.stringify(3)}>
                                    <Card.Body>
                                        <div className="row">
                                            <div className="col">
                                                <button className="btn2 btn-sms1 float-right rounded-pill" type="submit" onClick={() => this.handleRevise()}> Recall Payment </button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="w-block1 pr-4 sticky" >
                                                <div className="scrolling-bar-table wrap">
                                                    <table border="1" className="table1 table-exp " >
                                                        <>
                                                            <tr className="headerbar sticky-inner ">
                                                                <th><input type="checkbox" onClick={this.handleChangeRecall} checked={this.state.selectRecall} /></th>
                                                                <th style={{ minWidth: "59px" }}>Action</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Plant Code</th>
                                                                <th>Invoice No</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Payment Counter</th>
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "82px" }}>Invoice Date</th>
                                                                {/* Editable Due Date */}
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "82px" }}>Due Date</th>
                                                                <th style={{ minWidth: "255px" }}>Vendor Name</th>
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "149px" }}>Invoice Type</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Vendor Type</th>
                                                                <th>PO No</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Project code</th>
                                                                <th>currency</th>
                                                                <th>Invoice Amount</th>
                                                                <th>Invoice Amount in (INR)</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Advance Deduction</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Retention Deduction</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>LD Deduction</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>TDS Deduction</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Others Deduction</th>
                                                                {/* Text Field */}
                                                                <th>Reason For Others</th>
                                                                {/* Text Field */}
                                                                <th style={{ whiteSpace: "break-spaces" }}>SAP Doc. Number</th>
                                                                {/* Date Field */}
                                                                <th style={{ whiteSpace: "break-spaces", minWidth: "82px" }}>SAP Doc. Date</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Net Payable Amount</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Approved Amount</th>
                                                                <th style={{ whiteSpace: "break-spaces" }}>Payment Method</th>
                                                                <th style={{ minWidth: "126px" }}>Status</th>
                                                            </tr>
                                                        </>
                                                        <>
                                                            {this.state.invoiceDataSendForPayment.map((item, Index) =>

                                                                <tr className="rows headeralign">
                                                                    <td>
                                                                        {item.InvoiceStatusId <= 6 ? <input type="checkbox" disabled={item.Priority == 'Hold' ? true : false} checked={this.state.checkedArrayRecall.includes(item.InvoiceId) ? true : false} onChange={(event) => this.handleRecallSingleCheckboxChange(item.InvoiceId)} value="" /> : null}</td>
                                                                    <td>
                                                                        <Link to={{ pathname: '/PoAcceptanceTrail', state: { poId: item.PurchaseOrderId, poSAPId: item.POSAPId, InvoiceId: item.InvoiceId, InvoiceStatusId: item.InvoiceStatusId } }}>
                                                                            <FontAwesomeIcon icon={"eye"} color="black" title="View" size="lg" />
                                                                        </Link>
                                                                        <FontAwesomeIcon icon={"sms"} style={{ marginLeft: "10px" }} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(item.InvoiceId)} />
                                                                    </td>
                                                                    <td>{item.PlantCode}</td>
                                                                    <td>{item.InvoiceNo}</td>
                                                                    <td>{item.Counter > 0 ? `Part-${item.Counter}` : ''}</td>
                                                                    <td>{dateFormater(this.formatDate(item.InvoiceDate))}</td>
                                                                    <td>{dateFormater(this.formatDate(item.DueDate))}</td>
                                                                    <td>{item.VendorName + " - " + item.VendorSapId}</td>
                                                                    <td>{item.PaymentTypeName + " Against " + item.TypeFor}</td>
                                                                    <td>{item.SSIType == "" ? "NON MSME" : "MSME"}</td>
                                                                    <td>{item.POSAPId}</td>
                                                                    <td>
                                                                        {item.WBSNo ? item.WBSNo.includes('ET') ? (item.WBSNo).slice(0, 11) : (item.WBSNo).slice(0, 6) : ""}
                                                                    </td>
                                                                    <td>{item.CurrencyType}</td>
                                                                    <td className="align-middle amount-text">{item.InvoiceAmount ? numberWithCommas(item.InvoiceAmount) : 0} </td>
                                                                    <td className="align-middle amount-text">{item.InvoiceAmountinINR ? numberWithCommas(item.InvoiceAmountinINR) : 0}</td>
                                                                    <td className="align-middle amount-text">{item.AdvanceDeduction ? item.CurrencyType + " " + numberWithCommas(item.AdvanceDeduction) : 0}</td>
                                                                    <td className="align-middle amount-text">{item.RetentionDeduction ? item.CurrencyType + " " + numberWithCommas(item.RetentionDeduction) : 0}</td>
                                                                    <td className="align-middle amount-text">{item.LDDeduction ? item.CurrencyType + " " + numberWithCommas(item.LDDeduction) : 0}</td>
                                                                    <td className="align-middle amount-text">{item.TDSDeduction ? item.CurrencyType + " " + numberWithCommas(item.TDSDeduction) : 0}</td>
                                                                    <td className="align-middle amount-text">{item.OthersDeduction ? item.CurrencyType + " " + numberWithCommas(item.OthersDeduction) : 0}</td>
                                                                    <td>{item.ReasonForOthersDeduction != '0' ? item.ReasonForOthersDeduction : ''}</td>
                                                                    <td>{item.SAPDocNo}</td>
                                                                    <td>{item.SAPDocDate ? dateFormater(item.SAPDocDate) : ""}</td>
                                                                    <td className="align-middle amount-text">{numberWithCommas(item.NetPayableAmount)}</td>
                                                                    <td className="align-middle amount-text">{item.PayableAmount ? numberWithCommas(item.PayableAmount) : 0}</td>
                                                                    <td>{item.PaymentMediumName}</td>
                                                                    <td>{item.InvoiceStatusName}</td>
                                                                </tr>
                                                            )}
                                                        </>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </>
                    : (roles[9] && groups[10]) || roles[54] ?
                        <div className="row sticky pr-2">
                            <div className="centre-alligned wrap" >
                                <div className="table1 table-exp">
                                    <table border="1" className=" payment-table" >
                                        <>
                                            <tr className="headerbar sticky-inner">
                                                <th style={{ whiteSpace: "break-spaces" }}>Plant Code</th>
                                                <th>Invoice No</th>
                                                <th style={{ whiteSpace: "break-spaces" }}>Payment Counter</th>
                                                <th style={{ whiteSpace: "break-spaces", minWidth: "82px" }}>Invoice Date</th>
                                                {/* Editable Due Date */}
                                                <th style={{ whiteSpace: "break-spaces", minWidth: "82px" }}>Due Date</th>
                                                <th style={{ minWidth: "255px" }}>Vendor Name</th>
                                                <th style={{ whiteSpace: "break-spaces", minWidth: "149px" }}>Invoice Type</th>
                                                <th style={{ whiteSpace: "break-spaces" }}>Vendor Type</th>
                                                <th>PO No</th>
                                                <th style={{ whiteSpace: "break-spaces" }}>Project code</th>
                                                <th>Currency</th>
                                                <th>Invoice Amount</th>
                                                <th>Invoice Amount in (INR)</th>
                                                <th style={{ whiteSpace: "break-spaces" }}>Advance Deduction</th>
                                                <th style={{ whiteSpace: "break-spaces" }}>Retention Deduction</th>
                                                <th style={{ whiteSpace: "break-spaces" }}>LD Deduction</th>
                                                <th style={{ whiteSpace: "break-spaces" }}>TDS Deduction</th>
                                                <th style={{ whiteSpace: "break-spaces" }}>Others Deduction</th>
                                                {/* Text Field */}
                                                <th>Reason For Others</th>
                                                {/* Text Field */}
                                                <th style={{ whiteSpace: "break-spaces" }}>SAP Doc. Number</th>
                                                {/* Date Field */}
                                                <th style={{ whiteSpace: "break-spaces", minWidth: "82px" }}>SAP Doc. Date</th>
                                                <th style={{ whiteSpace: "break-spaces" }}>Net Payable Amount</th>
                                                <th style={{ whiteSpace: "break-spaces" }}>Payment Method</th>
                                                <th style={{ minWidth: "126px" }}>Status</th>
                                                <th style={{ minWidth: "59px" }}>Action</th>
                                            </tr>
                                        </>
                                        <>
                                            {this.state.invoiceDataSendForPayment && this.state.invoiceDataSendForPayment.map((item, Index) =>

                                                <tr className="rows headeralign">
                                                    <td>{item.PlantCode}</td>
                                                    <td>{item.InvoiceNo}</td>
                                                    <td>{item.Counter > 0 ? `Part-${item.Counter}` : ''}</td>
                                                    <td>{dateFormater(this.formatDate(item.InvoiceDate))}</td>
                                                    <td>{dateFormater(this.formatDate(item.DueDate))}</td>
                                                    <td>{item.VendorName + " - " + item.VendorSapId}</td>
                                                    <td>{item.PaymentTypeName + " Against " + item.TypeFor}</td>
                                                    <td>{item.SSIType == "" ? "NON MSME" : "MSME"}</td>
                                                    <td>{item.POSAPId}</td>
                                                    <td>
                                                        {item.WBSNo ? item.WBSNo.includes('ET') ? (item.WBSNo).slice(0, 11) : (item.WBSNo).slice(0, 6) : ""}
                                                    </td>
                                                    <td>{item.CurrencyType}</td>
                                                    <td className="align-middle amount-text">{item.InvoiceAmount ? numberWithCommas(item.InvoiceAmount) : 0} </td>
                                                    <td className="align-middle amount-text">{item.InvoiceAmountinINR ? numberWithCommas(item.InvoiceAmountinINR) : 0}</td>
                                                    <td className="align-middle amount-text">{item.AdvanceDeduction ? numberWithCommas(item.AdvanceDeduction) : 0}</td>
                                                    <td className="align-middle amount-text">{item.RetentionDeduction ? numberWithCommas(item.RetentionDeduction) : 0}</td>
                                                    <td className="align-middle amount-text">{item.LDDeduction ? numberWithCommas(item.LDDeduction) : 0}</td>
                                                    <td className="align-middle amount-text">{item.TDSDeduction ? numberWithCommas(item.TDSDeduction) : 0}</td>
                                                    <td className="align-middle amount-text">{item.OthersDeduction ? numberWithCommas(item.OthersDeduction) : 0}</td>
                                                    <td>{item.ReasonForOthersDeduction}</td>
                                                    <td>{item.SAPDocNo}</td>
                                                    <td>{item.SAPDocDate ? dateFormater(item.SAPDocDate) : ""}</td>
                                                    <td className="align-middle amount-text">{numberWithCommas(item.NetPayableAmount)}</td>
                                                    <td>{item.PaymentMediumName}</td>
                                                    <td>{item.InvoiceStatusName}</td>
                                                    <td>
                                                        <Link to={{ pathname: '/PoAcceptanceTrail', state: { poId: item.PurchaseOrderId, poSAPId: item.POSAPId, InvoiceId: item.InvoiceId, InvoiceStatusId: item.InvoiceStatusId } }}>
                                                            <FontAwesomeIcon icon={"eye"} color="black" title="View" size="lg" />
                                                        </Link>
                                                        <FontAwesomeIcon icon={"sms"} style={{ marginLeft: "10px" }} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(item.InvoiceId)} />
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    </table>
                                </div>
                            </div>
                        </div>
                        : null
                }
                <br />
                <br />
                <br />
            </div>
        )
    }
}
const mapStateToProps = (state) => ({ invoices: state.invoice, masterReducerData: state.masterReducer, poDetails: state.poDetails })
export default connect(mapStateToProps, {
    getAllInvoices, getDueAmounts, setInvoicePaymentMedium,
    getallMasterData, updateStatusForFinance, getBudgetAmount, insertbudgetamount, updatePriority, updateCommentInInvoice, updatePayableAmountInInvoice, PaymentTermDocumentsApprovalByPMs, getPaymentTermDocuments, GetDocumentsFromPaymentTermsByPoIdMultiple
})(ReqPayment)